import React from "react"

import { Link } from "gatsby"

import { Cross } from "akar-icons"
import PropTypes from "prop-types"
import Fade from "react-reveal/Fade"

import "./AnnouncementBar.scss"

const AnnouncementBar = ({ section }) => {
  const handleRemove = () => {
    document.querySelector(".announcement-bar").remove()
  }
  return (
    <section
      className="announcement-bar"
      style={{
        top:
          (section.positionTopOrBottom.toLowerCase() === "top" ||
            !section.positionTopOrBottom) &&
          0,
        bottom: section.positionTopOrBottom.toLowerCase() === "bottom" && 0,
        backgroundColor: section.color || "black",
      }}
    >
      <Fade>
        <div className="announcement-bar__main">
          <p className="announcement-bar__main__text">
            {section.text ||
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore"}
            ,{" "}
            <Link to={`/${section.link}`}>
              {section.textForLink || "Click Here"}
            </Link>
          </p>
          <button
            className="announcement-bar__main__btn"
            onClick={handleRemove}
          >
            <Cross strokeWidth={3} size={20} color="var(--color-lightest)" />
          </button>
        </div>
      </Fade>
    </section>
  )
}

AnnouncementBar.propTypes = {
  section: PropTypes.object.isRequired,
}

export default AnnouncementBar
